// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Order_wrapperComponent__cDch7","company":"Order_company__l7qpg","title":"Order_title__Kg+56","label":"Order_label__uxAbz"};